
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Component_30_2","data-name":"Component 30 – 2","xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"Rectangle_16409","data-name":"Rectangle 16409","width":"15","height":"15","fill":"none"}}),_c('g',{attrs:{"id":"Group_48358","data-name":"Group 48358","transform":"translate(3.484 3.486)","fill":"none","stroke":"#727998","stroke-linecap":"round","stroke-width":"1.2"}},[_c('line',{attrs:{"id":"Line_1794","data-name":"Line 1794","x2":"8.029","y2":"8.029"}}),_c('line',{attrs:{"id":"Line_1795","data-name":"Line 1795","x1":"8.029","y2":"8.029"}})])])
          )
        }
      }
    